// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { User } from '@interfaces/user.interfaces';
import { ReasonForRequestStatus, TradeInVehicle, Vehicle } from '@interfaces/vehicle.interfaces';
import { DealDocuments } from './document.interfaces';

export interface Deal {
    dealId: number;
    dealerDealNumber: string;
    dealTypeName?: string;
    statusId: number;
    dealerId: number;
    hasOpenDocuments: boolean;
    numberOfOpenDocuments: number;
    numberOfClosedDocuments: number;
    lastDocumentUploadDate: Date;
    isNew: boolean;
    isUsed: boolean;
    isBuy: boolean;
    isLease: boolean;
    isCash: boolean;
    isFinance: boolean;
    isTradeIn: boolean;
    isLeaseTurnIn: boolean;
    createDate: string; //date
    createdBy: number; //user_id
    createdByUser: User;
    lastUpdateDate: string; //date
    lastUpdateBy: number; //user_id
    lastUpdateByIPAddress?: string; //ip_address
    buyer: User;
    coBuyer: User;
    dealerContact: User;
    salesperson: User;
    vehicle: Vehicle;
    tradeInVehicle?: TradeInVehicle;
    dealershipName: string;
    listOfDocuments: string[];
    dealDocs?: DealDocuments;
    jacketTypeId?: JacketType;
    notes?: string;
    reasonForRequest?: ReasonForRequestStatus;
    deleteReason?: string;
}

export enum DealStatuses {
    Open = 1,
    Completed = 2,
    Archived = 3,
    Deleted = 4,
}

export enum JacketType {
    Deal = 1,
    Document = 2,
    Storage = 3,
}

export enum SelectedDealType {
    Express = 'Express Upload',
    Blank = 'Blank Deal',
    Custom = 'Custom Deal Type',
    DealType = 'Deal Type',
}

export interface DealData {
    count: number;
    deals: Deal[];
}

export interface AuditTrail {
    dealId?: number;
    dealerDealNumber?: number;
    buyerName?: string;
    comments?: string;
    previousValues?: string;
    currentValues?: string;
    runDate: any;
    activityDate?: any;
    documentId?: number;
    documentName?: string;
    actionPerformedBy?: string;
    actionPerformed?: string;
    iconName: string;
}

export enum VehicleType {
    Vehicle = 1,
    TradeIn = 2,
}
